// Utils
import { addMonths, subMonths } from 'date-fns';

// Hooks
import useSearchParams from './useSearchParams';

const useMonthSelector = () => {
  const { getSearchParams, updateSearchParams } = useSearchParams();

  const {
    year = new Date().getFullYear().toString(),
    month = new Date().getMonth().toString(),
  } = getSearchParams();

  const handleMonthSelectorClick = (side) => {
    const currentViewDate = new Date(year, Number(month));

    switch (side) {
      case 'previous': {
        const newViewDate = subMonths(currentViewDate, 1);
        return updateSearchParams({
          year: newViewDate.getFullYear(),
          month: newViewDate.getMonth(),
        }, true);
      }
      case 'next': {
        const newViewDate = addMonths(currentViewDate, 1);
        return updateSearchParams({
          year: newViewDate.getFullYear(),
          month: newViewDate.getMonth(),
        }, true);
      }
      default: return null;
    }
  };

  const setMonthFilterOnToday = () => {
    updateSearchParams({
      year: new Date().getFullYear().toString(),
      month: new Date().getMonth().toString(),
    }, true);
  };

  return {
    handleMonthSelectorClick,
    setMonthFilterOnToday,
  };
};

export default useMonthSelector;
